<template>
    <ContentWrapper>
        <breadcrumb/>

        <b-container>

            <div class="mb-5 animated-fast fadeInDown">

              <Assistant></Assistant>

            </div>

            <tickets :limit="5" class="mb-5"></tickets>

            <div v-for="(category,catIndex) in categories" class="mb-5" v-show="category.questions.length">

                <h4 class="animated-fast fadeInDown"><i :class="category.icon" class="mr-2"></i> {{ category.name }}</h4>

                <accordion-card v-for="(entry, index) in category.questions" @opened="opened(entry)" :key="'index' + index" class="animated-fast fadeInLeft"
                                :style="{'animation-delay': (100*(index+catIndex)) + 'ms'}">
                    <template v-slot:title>
                        {{ entry.question }}
                    </template>

                  <formatted-html :html="entry.answer"></formatted-html>

                </accordion-card>

            </div>

        </b-container>
    </ContentWrapper>
</template>
<script>
    import AccordionCard from "../components/AccordionCard";
    import Assistant from "../components/Assistant";
    import Tickets from "../components/Tickets";
    import FormattedHtml from "@/components/Common/FormattedHtml.vue";

    export default {
        components: {
          FormattedHtml,
            Tickets,
            Assistant,
            AccordionCard
        },
        data() {
            return {
                selected: undefined,
                categories: [],
                question: ''
            }
        },
        mounted() {
            this.$api.get('support/categories?html', {language: this.$i18n.locale}).then(response => {
                this.categories = response.data;
            });
        },
        methods: {
            opened(entry) {
                if (!entry.opened) {
                    this.$api.post('support/question/' + entry.id + '/opened');
                    entry.opened = true;
                }
            }
        }
    }
</script>